import { IAnyObject } from "../../interfaces";
import { Device } from "../Device";

export default class Envirotainer extends Device {

  constructor(data: IAnyObject) {
    super(data);
  }
}
